import React, {useContext} from 'react';
import {Route, RouteProps} from 'react-router';
import {useCheckAuth} from './useCheckAuth';
import {OAuthManagerContext} from "./context";
import {useAuthentication} from "../../hook/useAuthentication";
import {LoadingSpinner} from "../../../common";
import {useCurrentUser} from "../CurrentUser";
import {Alert, Pane} from "evergreen-ui";
import { extractCompositedRoleFromCurrentUser } from 'security';
import { intersection } from 'lodash';

type JwtSecuredRouteProps = {
    allowedRoles?: readonly string[];
} & RouteProps
export const AzurePortalSecuredRoute = ({allowedRoles, ...routerProps}: JwtSecuredRouteProps) => {
    const currentUser = useCurrentUser();

    const oauthManager = useContext(OAuthManagerContext)!;
    const {hasExplicitlySignedOut} = useAuthentication();
    const {checking, isAuthenticated} = useCheckAuth(oauthManager);

    if (hasExplicitlySignedOut()) {
        return (<LoadingSpinner text={"signed out"}/>); // TODO: handle logout correctly
    }

    if (checking) {
        return <LoadingSpinner centerScreen/>;
    }

    if (!isAuthenticated || !currentUser) {
        window.location.href = oauthManager.loginUrl(btoa(JSON.stringify({
            successUri: window.location.href.replace(window.location.origin, '')
        })));
        return null;
    }

    if ( allowedRoles && (intersection(allowedRoles, extractCompositedRoleFromCurrentUser(currentUser))).length === 0) {
        return (
            <Pane height='100vh'>
                <Alert intent='danger' title='Insufficient Permission'>
                    You do not have permission to view this page.
                </Alert>
            </Pane>
        );
    }

    return (<Route {...routerProps}/>);
};
